<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                
        <vue-particles
        color="#dedede"
        :particleOpacity="0.7"
        :particlesNumber="80"
        shapeType="circle"
        :particleSize="4"
        linesColor="#dedede"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
      >
      </vue-particles>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile" no-body style="margin-top:-400px !important">
                    <div class="px-4">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img v-lazy="'img/theme/team-1-800x800.jpg'" class="rounded-circle">
                                    </a>
                                </div>
                            </div>
                            <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
                                <!-- <div class="card-profile-actions py-4 mt-lg-0">
                                    <base-button type="info" size="sm" class="mr-4">Connect</base-button>
                                    <base-button type="default" size="sm" class="float-right">Message</base-button>
                                </div> -->
                            </div>
                            <div class="col-lg-4 order-lg-1">
                                <div class="card-profile-stats d-flex justify-content-center">
                                    <div>
                                        <!-- <span class="heading">22</span>
                                        <span class="description">Friends</span> -->
                                    </div>
                                    <div>
                                        <!-- <span class="heading">10</span>
                                        <span class="description">Photos</span> -->
                                    </div>
                                    <div>
                                        
                                        <span class="heading">&nbsp;</span>
                                        <span class="description">&nbsp;</span>
                                        <!-- <span class="heading">89</span>
                                        <span class="description">Comments</span> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-5">
                            <h1>ABHISHEK KRISHNAN</h1>                            
                            <div class="h3 mt-4"><i class="ni business_briefcase-24 mr-2"></i>IT Solutions Expert | Wildlife Enthusiast</div>
                            <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>New Delhi, India</div>
                        </div>
                        <div class="mt-5 py-5 border-top text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-9">
                                    <p class="text-justify">A trained engineer from Kerala, conservationist at heart and a wildlife passionate, I use my skills to bridge the gap between technology and conservation. Coding excites me, devising new mechanisms to meet technical challenges thrills me and photography is something where I find my solacing. </p>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>

        <section class="section section-skew">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-12">
                                <div class="text-center">
                                    <h2 class="display-3">Expertise In</h2>
                                </div>
                            </div>
                        </div>
                        <div class="row row-grid">
                            <div class="col-lg-4 text-center">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <img src="img/icons/node-js.png" style="height:80px; width:auto" class="rounded">
                                    <br><br>
                                    <h6 class="text-primary text-uppercase">Node JS</h6>
                                    <!-- <p class="description mt-3 text-justify">Argon is a great free UI package based on Bootstrap 4
                                        that includes the most important components and features.</p>
                                    <div>
                                        <badge type="primary" rounded>design</badge>
                                        <badge type="primary" rounded>system</badge>
                                        <badge type="primary" rounded>creative</badge>
                                    </div> -->
                                    <base-progress v-bind="progress_1"></base-progress>
                                </card>
                            </div>
                            <div class="col-lg-4 text-center">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <img src="img/icons/aws.png" style="height:80px; width:auto" class="rounded">
                                    <br><br>
                                    <h6 class="text-success text-uppercase">Amazon Web Services</h6>
                                    <!-- <p class="description mt-3 text-justify">Argon is a great free UI package based on Bootstrap
                                        4 that includes the most important components and features.</p>
                                    <div>
                                        <badge type="success" rounded>business</badge>
                                        <badge type="success" rounded>vision</badge>
                                        <badge type="success" rounded>success</badge>
                                    </div> -->
                                    <base-progress v-bind="progress_2"></base-progress>
                                </card>
                            </div>
                            <div class="col-lg-4 text-center">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <img src="img/icons/vue-js.png" style="height:80px; width:auto" class="rounded">
                                    <br><br>
                                    <h6 class="text-warning text-uppercase">Vue JS</h6>
                                    <!-- <p class="description mt-3 text-justify">Argon is a great free UI package based on Bootstrap
                                        4 that includes the most important components and features.</p>
                                    <div>
                                        <badge type="warning" rounded>marketing</badge>
                                        <badge type="warning" rounded>product</badge>
                                        <badge type="warning" rounded>launch</badge>
                                    </div> -->
                                    <base-progress v-bind="progress_3"></base-progress>
                                </card>
                            </div>
                        </div>
                        <div class="row row-grid">
                            <div class="col-lg-4 text-center">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <img src="img/icons/photoshop.png" style="height:80px; width:auto" class="rounded">
                                    <br><br>
                                    <h6 class="text-primary text-uppercase">Adobe Photoshop</h6>
                                    <!-- <p class="description mt-3 text-justify">Argon is a great free UI package based on Bootstrap 4
                                        that includes the most important components and features.</p>
                                    <div>
                                        <badge type="primary" rounded>design</badge>
                                        <badge type="primary" rounded>system</badge>
                                        <badge type="primary" rounded>creative</badge>
                                    </div> -->
                                    <base-progress v-bind="progress_4"></base-progress>
                                </card>
                            </div>
                            <div class="col-lg-4 text-center">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <img src="img/icons/mongoDB.png" style="height:80px; width:auto" class="rounded">
                                    <br><br>
                                    <h6 class="text-success text-uppercase">Mongo DB</h6>
                                    <!-- <p class="description mt-3 text-justify">Argon is a great free UI package based on Bootstrap
                                        4 that includes the most important components and features.</p>
                                    <div>
                                        <badge type="success" rounded>business</badge>
                                        <badge type="success" rounded>vision</badge>
                                        <badge type="success" rounded>success</badge>
                                    </div> -->
                                    <base-progress v-bind="progress_5"></base-progress>
                                </card>
                            </div>
                            <div class="col-lg-4 text-center">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <img src="img/icons/wireless-networking.png" style="height:80px; width:auto" class="rounded">
                                    <br><br>
                                    <h6 class="text-warning text-uppercase">Wireless Networking</h6>
                                    <!-- <p class="description mt-3 text-justify">Argon is a great free UI package based on Bootstrap
                                        4 that includes the most important components and features.</p>
                                    <div>
                                        <badge type="warning" rounded>marketing</badge>
                                        <badge type="warning" rounded>product</badge>
                                        <badge type="warning" rounded>launch</badge>
                                    </div> -->
                                    <base-progress v-bind="progress_6"></base-progress>
                                </card>
                            </div>
                        </div>
                        <div class="row row-grid">
                            <div class="col-lg-4 text-center">
                                <!-- <card class="border-0" hover shadow body-classes="py-5">
                                    <img src="img/icons/node-js.png" style="height:80px; width:auto" class="rounded">
                                    <br><br>
                                    <h6 class="text-primary text-uppercase">Node JS</h6>
                                    <p class="description mt-3 text-justify">Argon is a great free UI package based on Bootstrap 4
                                        that includes the most important components and features.</p>
                                    <div>
                                        <badge type="primary" rounded>design</badge>
                                        <badge type="primary" rounded>system</badge>
                                        <badge type="primary" rounded>creative</badge>
                                    </div>
                                    <base-progress v-bind="progress_1"></base-progress>
                                </card> -->
                            </div>
                            <div class="col-lg-4 text-center">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <img src="img/icons/flutter.png" style="height:80px; width:auto" class="rounded">
                                    <br><br>
                                    <h6 class="text-success text-uppercase">Flutter</h6>
                                    <!-- <p class="description mt-3 text-justify">Argon is a great free UI package based on Bootstrap
                                        4 that includes the most important components and features.</p>
                                    <div>
                                        <badge type="success" rounded>business</badge>
                                        <badge type="success" rounded>vision</badge>
                                        <badge type="success" rounded>success</badge>
                                    </div> -->
                                    <base-progress v-bind="progress_7"></base-progress>
                                </card>
                            </div>
                            <div class="col-lg-4 text-center">
                                <!-- <card class="border-0" hover shadow body-classes="py-5">
                                    <img src="img/icons/vue-js.png" style="height:80px; width:auto" class="rounded">
                                    <br><br>
                                    <h6 class="text-warning text-uppercase">Vue JS</h6>
                                    <p class="description mt-3 text-justify">Argon is a great free UI package based on Bootstrap
                                        4 that includes the most important components and features.</p>
                                    <div>
                                        <badge type="warning" rounded>marketing</badge>
                                        <badge type="warning" rounded>product</badge>
                                        <badge type="warning" rounded>launch</badge>
                                    </div>
                                    <base-progress v-bind="progress_3"></base-progress>
                                </card> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

                <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-warning shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                            <img src="img/ill/ill-2.svg" class="img-center img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="d-flex px-3">
                            <div>
                                <icon name="ni ni-building" size="lg" class="bg-gradient-white" color="primary" shadow
                                      rounded></icon>
                            </div>
                            <div class="pl-4">
                                <h4 class="display-3 text-white">Services Offered</h4>
                                <!-- <p class="text-white">The Arctic Ocean freezes every winter and much of the sea-ice then
                                    thaws every summer, and that process will continue whatever happens.</p> -->
                            </div>
                        </div>
                        <card shadow class="shadow-lg--hover mt-3">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-html5" gradient="success" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-success">Web Development</h5>
                                    <p>Web applications powered by cloud platforms, with stunning interfaces.</p>
                                    
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover mt-3">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-app" gradient="warning" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-warning">Mobile App Development</h5>
                                    <p>Reach your client's palms with carefully designed mobile apps.</p>
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover mt-3">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="fa fa-database" gradient="primary" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-primary">Data Management</h5>
                                    <p>Forget the hassle of record keeping and scale your enterprise to the skies</p>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-skew">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-sm-4 col-md-6 order-md-2  order-sm-2">
                        <img src="img/theme/promo-1.png" class="img-fluid floating">
                    </div>
                    <div class="col-sm-8 col-md-6 order-md-1 order-sm-1">
                        <div class="pr-md-5">
                            <icon name="ni ni-settings-gear-65" class="mb-5" size="lg" type="success" shadow
                                  rounded></icon>
                            <h2 class="display-3">My Clients</h2>
                            <!-- <p>The kit comes with three pre-built pages to help you get started faster. You can change
                                the text and images and you're good to go.</p> -->
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-bold-right"></badge>
                                        <h6 class="mb-0"><a href="https://wii.gov.in" target="_blank">Wildlife Institute of India</a></h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-bold-right"></badge>
                                        <h6 class="mb-0"><a href="https://wti.org.in" target="_blank">Wildlife Trust of India</a></h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-bold-right"></badge>
                                        <h6 class="mb-0"><a href="https://iucn.org" target="_blank">International Union for Conservation of Nature</a></h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-bold-right"></badge>
                                        <h6 class="mb-0"><a href="http://leopardtechlabs.com" target="_blank">Leopard Tech Labs Pvt. Ltd.</a></h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-bold-right"></badge>
                                        <h6 class="mb-0"><a href="http://fawzlabs.com" target="_blank">Fawzlabs Private Limited</a></h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg pb-300">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Projects Undertaken</h2>
                    </div>
                </div>
                <div class="row row-grid mt-5 text-center">                    
                    <div class="col-lg-4">
                        
                        
                    </div>
                    <div class="col-lg-4">
                        <h5 class="text-white mt-3">Lockdown Wildlife Tracker</h5>
                        <p class="text-white mt-3 text-justify">An initiative to study straying of wildlife during lockdown by WII.</p>
                        <div>
                            <badge rounded>Node JS</badge>
                            <badge rounded>Vue JS</badge>
                            <badge rounded>Flutter</badge>
                            <badge rounded>Mobile App</badge>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        
                        
                    </div>
                </div>
                <div class="row row-grid mt-5 text-center">                    
                    <div class="col-lg-4">
                        <h5 class="text-white mt-3">WildWatch</h5>
                        <p class="text-white mt-3 text-justify">An integrated system to monitor and help mitigate Human-Wildlife Conflicts.</p>
                        <div>
                            <badge rounded>Node JS</badge>
                            <badge rounded>Vue JS</badge>
                            <badge rounded>Mobile App</badge>
                            <badge rounded>Sensor Systems</badge>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <h5 class="text-white mt-3">RoadWatch</h5>
                        <p class="text-white mt-3 text-justify">Citizen Science project to record and map animal roadkills accross the nation.</p>
                        <div>
                            <badge rounded>PHP</badge>
                            <badge rounded>MySQL</badge>
                            <badge rounded>Mobile App</badge>
                            <badge rounded>HTML</badge>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <h5 class="text-white mt-3">Big4Mapper</h5>
                        <p class="text-white mt-3 text-justify">App based monitoring system to monitor and map snakebites in India.</p>
                        <div>
                            <badge rounded>PHP</badge>
                            <badge rounded>MySQL</badge>
                            <badge rounded>Mobile App</badge>
                            <badge rounded>HTML</badge>
                        </div>
                    </div>
                </div>
                <div class="row row-grid mt-5 text-center">
                    <div class="col-lg-4">
                        <h5 class="text-white mt-3">Project HAWK</h5>
                        <p class="text-white mt-3 text-justify">Centralized system for Kerala Forest Department to monitor wildlife crime.</p>
                        <div>
                            <badge rounded>Node JS</badge>
                            <badge rounded>Vue JS</badge>
                            <badge rounded>Mobile App</badge>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <h5 class="text-white mt-3">Big Cat Conflict Portal</h5>
                        <p class="text-white mt-3 text-justify">Web Portal to analyze Big Cat Conflcits accross nation for WTI.</p>
                        <div>
                            <badge rounded>Node JS</badge>
                            <badge rounded>Vue JS</badge>
                            <badge rounded>Amazon AWS</badge>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <h5 class="text-white mt-3">Corridor Watch</h5>
                        <p class="text-white mt-3 text-justify">Mobile App & Website to monitor Elephant Corridors in India.</p>
                        <div>
                            <badge rounded>Node JS</badge>
                            <badge rounded>Vue JS</badge>
                            <badge rounded>Mobile App</badge>
                            <badge rounded>Amazon AWS</badge>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-skew mt--200" >
            <div class="container">
                <card gradient="warning"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <!-- <div class="col-lg-8">
                                <h3 class="text-white">We made website building easier for you.</h3>
                                <p class="lead text-white mt-3">I will be the leader of a company that ends up being
                                    worth billions of dollars, because I got the answers. I understand culture.</p>
                            </div> -->
                            <div class="col-lg-4"></div>
                            <!-- <div class="col-lg-4 ml-lg-auto"> -->
                            <div class="col-lg-4">
                                <base-button block type="white" class=" mb-3" @click="modal = true">
                                    Get in Touch!
                                </base-button>

                                <modal :show.sync="modal"
                                    gradient="danger"
                                    modal-classes="modal-danger modal-dialog-centered">
                                    <h6 slot="header" class="modal-title" id="modal-title-notification">Thank you for getting in touch!</h6>

                                    <div class="py-3 text-center">
                                        <i class="ni ni-badge ni-3x"></i>
                                        <h4 class="heading mt-4" style="text-transform:lowercase"><i class="fa fa-envelope" aria-hidden="true"></i>: mails@abhishkrish.com</h4>
                                        <h4 class="heading mt-4"><i class="fa fa-phone" aria-hidden="true"></i>: +91 807-815-3900</h4>
                                    </div>

                                    <template slot="footer">
                                        <base-button type="white" @click="modal = false">Ok, Got it</base-button>
                                        
                                    </template>
                                </modal>        
                                
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <!-- <section class="section section-skew">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3">Support Team</h2>
                        <p class="lead text-muted">According to the National Oceanic and Atmospheric Administration,
                            Ted, Scambos, NSIDClead scentist, puts the potentially record maximum.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/jose.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Jose Louies</span>
                                    <small class="h6 text-muted">Mentor</small>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://www.facebook.com/jose.louies" type="warning" icon="fa fa-facebook" rounded
                                                 icon-only></base-button>  
                                </div>
                            </div>                            
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/allen.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Allen Shaji</span>
                                    <small class="h6 text-muted">UI/UX Expert</small>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://www.facebook.com/allen.shaji.39" type="warning" icon="fa fa-facebook" rounded
                                                 icon-only></base-button>  
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/sobin.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Sobin Mathew</span>
                                    <small class="h6 text-muted">Mobile App Expert</small>
                                </h5>
                                <div class="mt-3">                                    
                                    <base-button tag="a" href="https://www.facebook.com/sobin.pullumattathil" type="warning" icon="fa fa-facebook" rounded
                                                 icon-only></base-button>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/ragini.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Ragini Shankar</span>
                                    <small class="h6 text-muted">Media & Marketing Expert</small>
                                </h5>
                                <div class="mt-3">
                                   <base-button tag="a" href="https://www.facebook.com/ragini.shankar.98" type="warning" icon="fa fa-facebook" rounded
                                                 icon-only></base-button>  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
    </div>
</template>
<script>
    import CustomControls from "./components/CustomControls";
    import Modal from "@/components/Modal.vue";
    import ProgressSection from "./components/JavascriptComponents/ProgressPagination";
    export default {
        components: {
            CustomControls,
            ProgressSection,
            Modal
        },
        data()  {
            return {
                progress_1 : {
                    value : 85,
                    label : null,
                    type : 'primary',
                    striped : true,
                    animated : true
                },
                progress_2 : {
                    value : 65,
                    label : null,
                    type : 'success',                    
                    striped : true,
                    animated : true
                },
                progress_3 : {
                    value : 55,
                    label : null,
                    type : 'warning',                    
                    striped : true,
                    animated : true
                },
                progress_4 : {
                    value : 65,
                    label : null,
                    type : 'primary',
                    striped : true,
                    animated : true
                },
                progress_5 : {
                    value : 85,
                    label : null,
                    type : 'success',                    
                    striped : true,
                    animated : true
                },
                progress_6 : {
                    value : 90,
                    label : null,
                    type : 'warning',                    
                    striped : true,
                    animated : true
                },
                progress_7 : {
                    value : 70,
                    label : null,
                    type : 'warning',                    
                    striped : true,
                    animated : true
                },
                modal : false
                
            }
        }
    };
</script>
<style>
</style>
